import ApiService from './api_services'

const SupportsApi = {
  agentList: function() {
    return ApiService.get('/supports/agent_list')
  }
}

export default SupportsApi